module.exports = __webpack_public_path__ + "static/media/open_url.5f6808b1.svg";